import { render, staticRenderFns } from "./situation-details.vue?vue&type=template&id=75bb90ec&lang=pug&"
import script from "./situation-details.vue?vue&type=script&lang=js&"
export * from "./situation-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bb90ec')) {
      api.createRecord('75bb90ec', component.options)
    } else {
      api.reload('75bb90ec', component.options)
    }
    module.hot.accept("./situation-details.vue?vue&type=template&id=75bb90ec&lang=pug&", function () {
      api.rerender('75bb90ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/situationDetails/drivingLicense/situation-details.vue"
export default component.exports